exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n    We want to use `upd-step-page` but it forces us to be wrapped in a `u-card`,\n    causing extra borders. Overriding `u-card`'s styling for now.\n  */\n  upd-moving-center-companies u-card {\n    background-color: transparent;\n    padding: 0;\n  }\n", ""]);

